import {useId} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {MULTILEAD_RESPONSIVE_MODAL_TEST_IDS} from "@pg-mono/test-ids";

import {leadModalZindex} from "../../constants/lead/lead_modal_zindex";
import {IApplicationMultiLeadProps} from "../../types/multi_lead/IApplicationMultiLeadProps";
import {ApplicationMultiLeadResponsiveModalContent} from "./ApplicationMultiLeadResponsiveModalContent";

interface IProps {
    isLoading: boolean;
    multiLeadProps: IApplicationMultiLeadProps | null;
    onClose: () => void;
}

export const ApplicationMultiLeadResponsiveModal = (props: IProps) => {
    const {isLoading, multiLeadProps, onClose} = props;
    const titleId = useId();
    const descriptionId = useId();
    const isContentShown = !isLoading && multiLeadProps !== null;

    return (
        <ResponsiveModal
            isOpen
            onClose={onClose}
            zIndex={leadModalZindex}
            contentLabel={!isLoading ? undefined : "Wczytywanie propozycji"}
            ariaLabelledBy={isContentShown ? titleId : undefined}
            ariaDescribedBy={isContentShown ? descriptionId : undefined}
            className={modalStyle}
            overlayClassName={overlayStyle}
            dataTestId={isLoading ? MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.LOADER : MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.WRAPPER}
        >
            {isContentShown ? (
                <ApplicationMultiLeadResponsiveModalContent {...multiLeadProps} titleId={titleId} descriptionId={descriptionId} />
            ) : (
                <>
                    <ResponsiveModal.Header divider={false} className={loaderHeaderStyle}>
                        <ResponsiveModal.CloseButton dataTestId={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.CLOSE_BUTTON} />
                    </ResponsiveModal.Header>
                    <ResponsiveModal.Body className={loaderBodyStyle}>{isLoading ? <Loader size="lg" fullWidth /> : null}</ResponsiveModal.Body>
                </>
            )}
        </ResponsiveModal>
    );
};

const modalStyle = css({
    "--responsive-modal-width": "81.2rem"
});

// Opened in place of a previous modal of the registration flow - the backdrop stays fully visible instead of fading in again
const overlayStyle = css({
    animation: "none"
});

const loaderHeaderStyle = css({
    display: "flex",
    justifyContent: "flex-end",
    px: 2,
    py: 1.5
});

const loaderBodyStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "24rem",
    px: 2,
    pb: 4,
    md: {
        minHeight: "28rem",
        px: 3
    }
});
import {useId} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {MULTILEAD_RESPONSIVE_MODAL_TEST_IDS} from "@pg-mono/test-ids";

import {leadModalZindex} from "../../constants/lead/lead_modal_zindex";
import {IApplicationMultiLeadProps} from "../../types/multi_lead/IApplicationMultiLeadProps";
import {ApplicationMultiLeadResponsiveModalContent} from "./ApplicationMultiLeadResponsiveModalContent";

interface IProps {
    isLoading: boolean;
    multiLeadProps: IApplicationMultiLeadProps | null;
    onClose: () => void;
}

export const ApplicationMultiLeadResponsiveModal = (props: IProps) => {
    const {isLoading, multiLeadProps, onClose} = props;
    const titleId = useId();
    const descriptionId = useId();
    const isContentShown = !isLoading && multiLeadProps !== null;

    return (
        <ResponsiveModal
            isOpen
            onClose={onClose}
            zIndex={leadModalZindex}
            contentLabel={!isLoading ? undefined : "Wczytywanie propozycji"}
            ariaLabelledBy={isContentShown ? titleId : undefined}
            ariaDescribedBy={isContentShown ? descriptionId : undefined}
            className={modalStyle}
            overlayClassName={overlayStyle}
            dataTestId={isLoading ? MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.LOADER : MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.WRAPPER}
        >
            {isContentShown ? (
                <ApplicationMultiLeadResponsiveModalContent {...multiLeadProps} titleId={titleId} descriptionId={descriptionId} />
            ) : (
                <>
                    <ResponsiveModal.Header divider={false} className={loaderHeaderStyle}>
                        <ResponsiveModal.CloseButton dataTestId={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.CLOSE_BUTTON} />
                    </ResponsiveModal.Header>
                    <ResponsiveModal.Body className={loaderBodyStyle}>{isLoading ? <Loader size="lg" fullWidth /> : null}</ResponsiveModal.Body>
                </>
            )}
        </ResponsiveModal>
    );
};

const modalStyle = css({
    "--responsive-modal-width": "81.2rem"
});

// Opened in place of a previous modal of the registration flow - the backdrop stays fully visible instead of fading in again
const overlayStyle = css({
    animation: "none"
});

const loaderHeaderStyle = css({
    display: "flex",
    justifyContent: "flex-end",
    px: 2,
    py: 1.5
});

const loaderBodyStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "24rem",
    px: 2,
    pb: 4,
    md: {
        minHeight: "28rem",
        px: 3
    }
});
